module.exports = __webpack_public_path__ + "img/icon-round.e7c23e5d.svg";